import { render, staticRenderFns } from "./StempelAnzahl.vue?vue&type=template&id=f64ffda2&scoped=true"
import script from "./StempelAnzahl.vue?vue&type=script&lang=js"
export * from "./StempelAnzahl.vue?vue&type=script&lang=js"
import style0 from "./StempelAnzahl.vue?vue&type=style&index=0&id=f64ffda2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64ffda2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f64ffda2')) {
      api.createRecord('f64ffda2', component.options)
    } else {
      api.reload('f64ffda2', component.options)
    }
    module.hot.accept("./StempelAnzahl.vue?vue&type=template&id=f64ffda2&scoped=true", function () {
      api.rerender('f64ffda2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/stempelkarte/StempelAnzahl.vue"
export default component.exports